import { useCallback } from 'react';
import { useWrapperSize } from '../../lib/selector-tab';
import { EElementSize } from '../../types';
import { InputWrapperStyled } from '../input-wrapper';
import { EState } from '../input-wrapper/input-wrapper.types';
import {
  SelectorTabItemStyled,
  SelectorTabStyled,
} from './selector-tab.styled';
import { ISelectorTabProps, TSelectorTabItemValue } from './selector-tab.types';

export function SelectorTab<T extends TSelectorTabItemValue>({
  options,
  value,
  disabled,
  $size = EElementSize.L,
  onSelect = () => {},
}: ISelectorTabProps<T>) {
  const wrapperSize = useWrapperSize($size);

  const clickHandler = useCallback(
    (value: T) => {
      if (disabled) {
        return;
      }

      onSelect(value);
    },
    [disabled, onSelect],
  );

  return (
    <SelectorTabStyled>
      <InputWrapperStyled
        $state={EState.NONE}
        $size={wrapperSize}
        $cursor="default"
        $isStatic={true}
        className="wrapper"
        disabled={disabled}
      >
        {options.map(option => (
          <SelectorTabItemStyled
            disabled={disabled}
            key={option.key}
            $size={$size}
            $isSelected={option.value === value}
            onClick={() => clickHandler(option.value)}
          >
            {option.caption}
          </SelectorTabItemStyled>
        ))}
      </InputWrapperStyled>
    </SelectorTabStyled>
  );
}
